import type { LoyaltyFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export const loyaltyProgramConnectedMockDataHandler: LoyaltyFragmentFragment = {
  connected: true,
  basePoints: 1500,
};

export const loyaltyProgramDisconnectedMockDataHandler: LoyaltyFragmentFragment = {
  connected: false,
  basePoints: 1500,
};
export const loyaltyProgramNullPointsMockDataHandler: LoyaltyFragmentFragment = {
  connected: false,
  basePoints: null,
};
